import Hero from "../components/Hero";
import WhyChooseUs from "../components/WhyChooseUs";
import MenuPreview from "../components/MenuPreview";
import Testimonials from "../components/Testimonials";
import GalleryPreview from "../components/GalleryPreview";

function Home() {
  return (
    <div>
      <Hero />
      <WhyChooseUs />
      <MenuPreview />
      <Testimonials />
      <GalleryPreview />
    </div>
  );
}

export default Home;
